export default {
  myCardList: [],

  selectedPageList: [],
};



// WEBPACK FOOTER //
// ./src/app/my-cards/store/state.js